import Dexie, { type Table } from "dexie";

// This interface should match the `orderEntry` created in `createOrderEntry`
// plus the properties needed for indexing.
export interface IOrderForDB {
    id: number;
    shopUrl: string;
    date: string; // The delivery/pickup date
    // ... all other properties from orderEntry
    menus: any[];
    status: string;
    line_items: any[];
    dailyId: string;
    shippingAddress: string;
    company: string;
    phone_delivery: string;
    phone: string;
    customerEmail: string;
    customerName: string;
    customerNote: string;
    isStammkunde: boolean | null;
    orderNumber: string;
    timeSlot: string;
    fsSlot: string;
    shippingMethod: string;
    paymentMethod: string;
    total: string;
    createdAt: string;
    modifiedAt: string;
    cancelled: boolean;
    totalValue: number;
    totalNetValue: number;
    totalNet: string;
    fsTags: string[];
    boxes: any[];
    packed: boolean;
    packedBy: string | null;
    distance: string;
    bearing: string;
    deliveryTimeframe: number;
    earliestTime: string | null;
    latestTime: string | null;
    directionsLink: string;
    originalAngebotOrderId: string;
    previousOrderId: string;
    dishes: any;
    service: any;
    hasEquipment: boolean;
    equipmentAmounts: any;
}

export class RefuEatDB extends Dexie {
    orders!: Table<IOrderForDB, [number, string]>; // Primary key is [order.id, dailyId]

    constructor() {
        super("refueatDB");
        this.version(4).stores({
            orders:
                // Primary key: '[id+dailyId]'
                // Indexes: 'id' for fetching all parts of an order, '[shopUrl+date]' is a compound index.
                // '*fsTags' is a multi-entry index for array searching.
                "[id+dailyId], id, [shopUrl+date], [id+shopUrl], shopUrl, date, status, modifiedAt, *fsTags",
        });
    }
}

export const db = new RefuEatDB();
